import { render, staticRenderFns } from "./IoObserver.vue?vue&type=template&id=bcdb724e&"
import script from "./IoObserver.vue?vue&type=script&lang=js&"
export * from "./IoObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports